import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'brand_leads-brands_form_mobile_navigation_first_back-click';

/**
 * Click on back in the first page of the mobile brands sign up form
 */
export function trackBrandLeadsBrandsFormMobileNavigationFirstBackClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
